import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import SetupYourAccountBG from "../../../../assets/images/payments/set-up-your-account-bg.png";
import {
  PaymentAccountEmailIcon,
  PaymentBankAccountIcon,
  PaymentWalletAccountIcon,
} from "../../../../assets/icons/MUI/PaymentIcons";

import { PaymentAccountProps } from "../../payment.types";

const commonStyle = {
  fontFamily: "Montserrat",
  fontSize: "14px",
  fontStyle: "normal",
  lineHeight: "20px",
};

const PaymentAccount = ({ user, handleAddReceivingDetails }: PaymentAccountProps) => {
  const { t } = useTranslation();

  const { bankName, currency, email, fullName, phoneNumber, type } = user;

  return (
    <Box
      sx={{
        boxShadow: "none",
        borderRadius: "12px !important",
        border: "1px solid #EAECF0",
        backgroundImage: `url(${SetupYourAccountBG})`,
        backgroundPosition: "right",
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        padding: "24px",
      }}
    >
      <Typography
        component="h5"
        sx={{
          color: "#1C1C1C",
          fontFamily: "Montserrat",
          fontSize: "20px",
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "30px",
          marginBottom: "6px",
        }}
      >
        {t("pages.payment.overview.paymentAccount")}
      </Typography>
      <Typography
        component="p"
        sx={{
          color: "#111",
          fontWeight: 400,
          marginBottom: "16px",
          ...commonStyle,
        }}
      >
        {t("pages.payment.overview.changePaymentMethod")}
      </Typography>
      <Box
        sx={{
          display: "flex",
          columnGap: "16px",
          padding: "16px",
          borderRadius: "8px",
          border: "1px solid #EAECF0",
          background: "#FFF",
        }}
      >
        <Box
          sx={{
            width: "40px",
            height: "40px",
            borderRadius: "6px",
            border: "1px solid var(--Gray-100, #F2F4F7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {type === "e_wallet" ? <PaymentWalletAccountIcon /> : <PaymentBankAccountIcon />}
        </Box>
        <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
          {fullName && (
            <Typography
              component="span"
              sx={{
                color: "#111",
                fontWeight: 500,
                ...commonStyle,
              }}
            >
              {fullName}
            </Typography>
          )}
          {bankName && (
            <Typography
              component="span"
              sx={{
                color: "#111",
                fontWeight: 500,
                ...commonStyle,
              }}
            >
              {bankName}
            </Typography>
          )}
          {phoneNumber && (
            <Typography
              component="span"
              sx={{
                color: "#111",
                fontWeight: 500,
                ...commonStyle,
              }}
            >
              {phoneNumber}
            </Typography>
          )}
          {currency && (
            <Typography
              component="span"
              sx={{
                color: "#111",
                fontWeight: 500,
                ...commonStyle,
              }}
            >
              {currency}
            </Typography>
          )}
          {email && (
            <Box sx={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <PaymentAccountEmailIcon />
              <Typography
                component="span"
                sx={{
                  color: "var(--Gray-600, #475467)",
                  fontFamily: "Montserrat",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "20px",
                }}
              >
                {email}
              </Typography>
            </Box>
          )}
        </Box>
        <Button
          variant="outlined-md"
          sx={{
            height: "fit-content",
          }}
          onClick={handleAddReceivingDetails}
        >
          {t("pages.payment.overview.edit")}
        </Button>
      </Box>
    </Box>
  );
};

export default PaymentAccount;
